import NumericCell from './NumericCell';

export default NumericCell;
